import React, { useContext, useEffect, useRef } from "react";
import { UNSAFE_DataRouterContext, useBlocker } from "react-router-dom";

function Guard({ dirty, recoveryAvailable }) {
  const blocker = useBlocker(({ currentLocation, nextLocation }) => dirty && currentLocation.pathname !== nextLocation.pathname);
  const dialog = useRef(null);
  useEffect(() => {
    if (blocker.state !== "blocked") return undefined;
    const focused = document.activeElement;
    const element = dialog.current;
    element?.showModal();
    return () => { element?.close(); focused?.focus?.(); };
  }, [blocker.state]);
  return blocker.state === "blocked" ? <dialog className="ds-leave-dialog" ref={dialog} aria-labelledby="ds-leave-title" onCancel={event => { event.preventDefault(); blocker.reset(); }}>
    <h2 id="ds-leave-title">Leave with unsaved changes?</h2>
    <p>{recoveryAvailable ? "Your setup draft is kept in this browser tab. It will be restored when you return, but the match has not been updated." : "This browser could not keep a recovery draft. Stay and save your changes to avoid losing them."}</p>
    <div className="ds-actions"><button autoFocus className="dp-button dp-primary" onClick={() => blocker.reset()}>Keep editing</button><button className="dp-button" onClick={() => blocker.proceed()}>{recoveryAvailable ? "Leave & keep draft" : "Leave without saving"}</button></div>
  </dialog> : null;
}
export default function SetupNavigationGuard(props) {
  const router = useContext(UNSAFE_DataRouterContext);
  return router ? <Guard {...props} /> : null;
}
